// BUY NOW on the home mood cards. Razorpay Magic Checkout handles .rzp-magic-btn__buy-product in its own
// capture-phase click listener (it stops the event), so this only runs while that script is still loading
// (on the home page it loads on first interaction): wait for it, click again, else fall back to /checkout.
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('.mood-buy');
  if (!btn) return;
  e.preventDefault();
  if (btn.dataset.waiting) return;
  var retried = btn.dataset.retried;
  btn.dataset.waiting = '1';
  btn.classList.add('is-loading');
  var start = Date.now();
  var magicReady = function () { return performance.getEntriesByName('listener-attached').length > 0; };
  (function wait() {
    if (magicReady() && !retried) {
      delete btn.dataset.waiting;
      btn.classList.remove('is-loading');
      btn.dataset.retried = '1';
      btn.click();
      setTimeout(function () { delete btn.dataset.retried; }, 1000);
      return;
    }
    if (!retried && Date.now() - start < 8000) return setTimeout(wait, 150);
    // Magic Checkout unavailable: normal Shopify checkout with this pack (other cart items stay).
    fetch('/cart/add.js', { method: 'POST', body: new FormData(btn.closest('form')) })
      .then(function () { location.href = '/checkout'; })
      .catch(function () { delete btn.dataset.waiting; btn.classList.remove('is-loading'); });
  })();
});
